// Shared constants for the Home dashboard.

export const SectionId = {
	R: "r",
	SEVERITY: "severity",
	DELAY: "delay",
	SCHEDULE: "schedule",
} as const;

export type SectionId = (typeof SectionId)[keyof typeof SectionId];

export const DOW_KOR = ["일", "월", "화", "수", "목", "금", "토"];

export const GRADE_BADGE: Record<string, string> = {
	NORMAL: "grade-chip--g1",
	CAUTION: "grade-chip--g2",
	WARNING: "grade-chip--g3",
	DANGER: "grade-chip--g3",
};

export const GRADE_SHORT_KEYS: Record<string, string> = {
	NORMAL: "medical:home.patientList.grade.g1Short",
	CAUTION: "medical:home.patientList.grade.g2Short",
	WARNING: "medical:home.patientList.grade.g3Short",
	DANGER: "medical:home.patientList.grade.g3Short",
};

export const SCH_TYPE_BADGE: Record<string, string> = {
	visit: "badge--green",
	call: "badge--blue",
	fu: "badge--purple",
	inperson: "badge--green",
};
